import React from 'react'
import { Box, Button, Flex, Heading, Message, Modal, Text } from '@workwhile/ui'
import { useUnassignRequirementFlowContextValue } from '../context/UnassignRequirementFlowProvider'
import { usePositionDetailWorkflowsContextValue } from '../../../context/PositionDetailWorkflowProvider'

const RequirementDataRow = ({
  label,
  value,
}: {
  label: string
  value: string
}) => (
  <Box>
    <Text fontWeight="bold">{label}</Text>
    <Text>{value}</Text>
  </Box>
)

export const UnassignRequirementFlowMain = () => {
  const {
    unassignRequirementFlow: { isOpen, close },
  } = usePositionDetailWorkflowsContextValue()

  const {
    state: { requirement, isPending, errorMessage },
    actions: { confirm },
  } = useUnassignRequirementFlowContextValue()

  return (
    <Modal
      open={isOpen}
      onClose={close}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm}>
            Remove
          </Button>
        </Flex>
      }
    >
      <Heading level={2} m={0}>
        Remove requirement from position
      </Heading>
      <Text mt={3} fontSize={4} fontWeight="bold">
        Are you sure you want to unassign this requirement from the position?
      </Text>

      <Flex mt={3} flexDirection="column" gap={3}>
        <RequirementDataRow
          label="Requirement Name (Id)"
          value={`${requirement.name} (${requirement.id})`}
        />
        <RequirementDataRow
          label="Verification Type"
          value={requirement.verificationType}
        />
        <RequirementDataRow label="Category" value={requirement.category} />
      </Flex>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
